<template>
  <div>
    <home-banner
      title="档案管理客户案例"
      description="由纸质档案向电子化档案转型的必选工具。"
    />
    <customer></customer>
  </div>
</template>

<script>
import homeBanner from './components/homeBanner.vue';
import customer from './components/customer.vue';
export default {
  components:{
    homeBanner,
    customer
  },
  data() {
    return {
      
    }
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  padding-top: 68px;
}
</style>